import { render, staticRenderFns } from "./CommunityBusinessnews.vue?vue&type=template&id=c93d8f1c&scoped=true&"
import script from "./CommunityBusinessnews.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessnews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93d8f1c",
  null
  
)

export default component.exports